import ArrowForward from '@mui/icons-material/ArrowForward';
import {
  Box,
  Card,
  CardActionArea,
  IconButton,
  Typography
} from '@mui/material';
import { useNavigate, Link as RouterLink } from 'react-router-dom';
import { Section } from './types';

export const DashBoardCard: React.FC<Section> = props => {
  const navigate = useNavigate();

  return (
    <Card
      sx={{
        boxShadow: 1,
        '&:hover': { boxShadow: 4 }
      }}
    >
      <CardActionArea
        component={RouterLink}
        to={props.link}
        sx={{
          p: 4,
          height: '100%'
        }}
      >
        <Box
          sx={{
            display: 'flex',
            gap: 1,
            mb: 2,
            justifyContent: 'space-between'
          }}
        >
          <Box
            sx={{
              display: 'flex',
              gap: 1
            }}
          >
            {props.logo}
            <Typography variant="h3">{props.title}</Typography>
          </Box>
          <IconButton onClick={() => navigate(props.link)}>
            <ArrowForward color="primary" />
          </IconButton>
        </Box>

        <Typography variant="body1">{props.description}</Typography>
      </CardActionArea>
    </Card>
  );
};
